import * as React from 'react';
// mui
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Snackbar,
  TextField,
  Typography
} from '@mui/material';
// axios
import api from '../../axios';

export default function BugReportPage() {
  const [ textContent, setTextContent ] = React.useState<string>('');
  const [ isLoading, setIsLoading ] = React.useState<boolean>(false);
  const [ showErrorBar, setShowErrorBar ] = React.useState<boolean>(false);
  const [ showSuccessBar, setShowSuccessBar ] = React.useState<boolean>(false);

  const handleBugReportSubmission = () => {
    setIsLoading(true);
    api.post('/bug', {
        content: textContent
      })
      .then((res) => {
        console.log(res);
        setShowSuccessBar(true);
        setTextContent('');
      })
      .catch((err) => {
        console.log(err);
        setShowErrorBar(true);
      })
      .finally(() => {
        setIsLoading(false);
      })
  }

  return (
    <Box
      display="flex"
      justifyContent="center"
      minHeight="calc(100vh - 112px)"
    >
      <Card sx={{ width: '100%', m: 0, p: 2 }} variant="outlined">
        <CardHeader 
          title="Bug Report"
          subheader="Helps fix issues by letting us know what happend."
        />
        <Divider />
        <CardContent>
          <TextField
            label="Please Describe What Happened"
            value={textContent}
            onChange={(e) => setTextContent(e.target.value)}
            sx={{ paddingBottom: 2 }}
            multiline
            rows={6}
            fullWidth
          />
          <Button
            fullWidth
            variant='contained'
            loading={isLoading}
            onClick={handleBugReportSubmission}
          >
            Submit
          </Button>
          <Typography sx={{ mt: 2}} variant="body2">By reporting bugs and issues you encounter, it allows us to know where we need to make improvements. We do our best to resolve all reported issues as quickly as possible. This app is still in the early stages of testing, issues are anticipated. We appreciate your feedback!</Typography>
        </CardContent>
      </Card>

      <Snackbar
        open={showErrorBar}
        autoHideDuration={6000}
        onClose={() => { setShowErrorBar(false); }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
      >
        <Alert
          severity="error"
          variant="filled"
          sx={{ width: '100%' }}
        >
          There was an error submitting the bug report (how ironic). You probably dont have internet!
        </Alert>
      </Snackbar>

      <Snackbar
        open={showSuccessBar}
        autoHideDuration={6000}
        onClose={() => { setShowSuccessBar(false); }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
      >
        <Alert
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          Thank you for your submission, we will address the issue shortly!
        </Alert>
      </Snackbar>
    </Box>
  );
}
